import { Card, Modal, Table } from "antd";
import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import "../../../../App.css";
import { RightCircleOutlined, LeftCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  apiCallStatus,
  SetWorkRequestData,
  fetchWorkRequestData,
  getMonthData,
} from "../actions/maintenanceDashboardService";
import {
  workRequestStatusData,
  doughnutOptions,
  WorkRequestcolumns,
  doughnutChartCenterValue,
  renderStatusData,
  handleChartClick,
  calculateYtdTotal,
} from "../constant/maintenanceConstantData";
import { WorkRequestChildComponent } from "../maintenanceCommonComponent";

const WorkRequestCard = ({
  handleChevronRightClick,
  setShowWorkRequestCard,
  showWorkRequestCard,
  searchedItem,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [requestYdtTotal, setRequestYtdTotal] = useState(0);
  const [openData, setOpenData] = useState([]);
  const [closeData, setCloseData] = useState([]);

  const [PageState, setPageState] = useState({
    currentPage: 1,
    pageSize: 10,
  });
  const dispatch = useDispatch();
  const [workRequestValue, setWorkRequestValue] = useState({
    WorkRequestChartData: null,
    WorkEquestModalData: null,
    workRequestYtdData: null,
  });

  const maintenanceDashboardList = useSelector((state) => state?.maintenanceDashboardList);
  useEffect(() => {
    if (maintenanceDashboardList) {
      setWorkRequestValue({
        WorkRequestChartData: maintenanceDashboardList?.WorkRequestChartData ,
        WorkEquestModalData: maintenanceDashboardList?.WorkEquestModalData ,
        workRequestYtdData: maintenanceDashboardList?.WorkRequestYtdData ,
      });
    }
  }, [maintenanceDashboardList]);

  // const {
  //   WorkRequestChartData,
  //   WorkEquestModalData,
  //   WorkRequestYtdData: workRequestYtdData,
  // } = useSelector((state) => state?.maintenanceDashboardList);
  useEffect(() => {
    if (workRequestValue?.WorkRequestChartData && workRequestValue?.WorkRequestChartData.length > 0) {
      const openDataValue = workRequestValue?.WorkRequestChartData.find(
        (item) => item.alertType === "Open"
      )?.total;
      const closeDataValue = workRequestValue?.WorkRequestChartData.find(
        (item) => item.alertType === "Close"
      )?.total;
      setOpenData(openDataValue);
      setCloseData(closeDataValue);
      const workRequestTotal = openDataValue + closeDataValue;
      const maintenanceWorkRequestScore =
        workRequestTotal !== 0
          ? ((closeDataValue / workRequestTotal) * 100).toFixed(2) + "%"
          : "0.00%";
      dispatch(apiCallStatus({ maintenanceWorkRequestScore }));
      const result = calculateYtdTotal(workRequestValue?.workRequestYtdData);
      setRequestYtdTotal(result);
    }
  }, [workRequestValue?.WorkRequestChartData, dispatch]);

  const labels = workRequestStatusData.map((item) => item.status);
  const backgroundColors = workRequestStatusData.map((item) => item.color);
  const workRequestData = {
    labels: labels,
    datasets: [
      {
        data: [openData, closeData],
        backgroundColor: backgroundColors,
        borderWidth: 1,
      },
    ],
  };

  const workRequestOptions = {
    ...doughnutOptions,

    onClick: (event, chartElements) =>
      handleChartClick(
        chartElements,
        workRequestData,
        searchedItem,
        setModalVisible,
        setSelectedLabel,
        dispatch,
        fetchWorkRequestData
      ),
  };

  const workRequestDataTextCenter = doughnutChartCenterValue("Realised");
  const handleModalClose = () => {
    setModalVisible(false);
    setPageState((prevState) => ({ ...prevState, currentPage: 1 }));
  };

  const pagination = {
    pageSize: PageState.pageSize, // Set the number of items per page
    current: PageState.currentPage, // Set the current page
    onChange: (page, pageSize) => {
      // Handle page change here, e.g., fetch and display data based on the new page and pageSize
      console.log(`Page: ${page}, PageSize: ${pageSize}`);
      setPageState({ currentPage: page, pageSize: pageSize });
    },
  };
  useEffect(() => {
    dispatch(
      SetWorkRequestData({
        workRequestData,
        requestYdtTotal,
      })
    );
  }, [openData,closeData]);

  const currentYear = searchedItem?.currentYear ?? new Date().getFullYear();

  const workRequestMonth = getMonthData(
    searchedItem?.currentYear ?? "",
    searchedItem?.currentMonth ?? ""
  );

  return (
    <>
      <Modal
        title={`${selectedLabel} Work Request`}
        open={modalVisible}
        width={1000}
        footer={[
          <button
            type="button"
            onClick={handleModalClose}
            className="btn muted-button  deca-btn-orange"
          >
            Close
          </button>,
        ]}
      >
        <div className="m-table__main">
          <div className="m-table__responsive large-width">
            <Table
              columns={WorkRequestcolumns}
              dataSource={workRequestValue?.WorkEquestModalData}
              pagination={pagination}
            />
          </div>
        </div>
      </Modal>
      <Card className={showWorkRequestCard ? "first-card-class" : "card-class"}>
        <div className={showWorkRequestCard ? "card-main-div" : ""}>
          <div className="card-first-div">
            <h3 className="card-heading">Maintenance Work Request</h3>
            <div className="chart-main-div">
              <div className="doughnut-chart-div">
                <Doughnut
                  data={workRequestData}
                  options={workRequestOptions}
                  plugins={[workRequestDataTextCenter]}
                />
              </div>

              <div className="asset-health-score-level">
                {renderStatusData(workRequestStatusData)}
              </div>
            </div>
          </div>
          <div className="work-request-icon-div">
            {showWorkRequestCard ? (
              ""
            ) : (
              <span
                onClick={() => {
                  handleChevronRightClick("work-request");
                }}
                className="right-circle-outlined-icon"
              >
                <RightCircleOutlined />
              </span>
            )}
          </div>

          {showWorkRequestCard && (
            <div className="showcard-card-class">
              <WorkRequestChildComponent
                workRequestMonth={workRequestMonth}
                openData={openData}
                closeData={closeData}
                currentYear={currentYear}
                requestYdtTotal={requestYdtTotal}
              />
              <div className="third-party-audit-icon-div">
                <span
                  className="left-circle-outlined-icon"
                  onClick={() => setShowWorkRequestCard(!showWorkRequestCard)}
                >
                  <LeftCircleOutlined />
                </span>
              </div>
            </div>
          )}
        </div>
      </Card>
    </>
  );
};

export default WorkRequestCard;
